function debounce(fn, wait) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
    };
}
class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.overlayCreated = false;
        this.input = this.querySelector('input[type="search"]');
        this.closeBtn = this.querySelector('button[close]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.input.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
        this.closeBtn.addEventListener('click', this.close.bind(this));
    }
    onChange() {
        const searchTerm = this.input.value.trim();
        if (!searchTerm.length) {
            this.close();
            return;
        }
        this.getSearchResults(searchTerm);
    }
    getSearchResults(searchTerm) {
        const url = `${routes.predictiveSearch}?q=${searchTerm}&resources[type]=product,collection&resources[limit]=10&section_id=predictive-search`;
        console.log(url);
        fetch(url)
            .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }
            return response.text();
        })
            .then((text) => {
            const resultsMarkup = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('#shopify-section-predictive-search').innerHTML;
            console.log(resultsMarkup);
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            this.open();
        })
            .catch((error) => {
            this.close();
            throw error;
        });
    }
    open() {
        this.predictiveSearchResults.style.display = 'grid';
        this.input.focus();
        document.documentElement.style.overflow = 'hidden';
        if (!this.overlayCreated) {
            this.createOverlay();
        }
    }
    close() {
        this.predictiveSearchResults.style.display = 'none';
        this.classList.remove('-active');
        document.documentElement.style.overflow = 'auto';
        this.input.value = '';
        this.predictiveSearchResults.innerHTML = '';
        this.removeOverlay();
    }
    createOverlay() {
        const overlay = document.createElement('div');
        overlay.classList.add('predictive-search-overlay');
        document.body.appendChild(overlay);
        overlay.addEventListener('click', this.close.bind(this));
        this.overlayCreated = true;
    }
    removeOverlay() {
        const overlay = document.querySelector('.predictive-search-overlay');
        if (overlay) {
            overlay.remove();
        }
        overlay.removeEventListener('click', this.close.bind(this));
        this.overlayCreated = false;
    }
}
if (!window.customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}
class OpenSearch extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.open.bind(this));
    }
    open() {
        const search = document.querySelector('predictive-search');
        search.classList.add('-active');
        search.open();
    }
}
if (!window.customElements.get('open-search')) {
    customElements.define('open-search', OpenSearch);
}
